import { PageHeader } from '@/components/PageHeader';
import { ProfilesTable } from './ProfilesTable';
import { CreateProfileModal } from './CreateProfileModal';
import { usePageTitle } from '@/hooks';

export const ProfilesPage = () => {
  usePageTitle('Profiles');
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader>
        <h1 className="text-3xl font-bold">Profiles</h1>
        <CreateProfileModal />
      </PageHeader>
      <ProfilesTable />
    </div>
  );
};
